export const LOAD_SYSTEM_STARTUP = 'LOAD_SYSTEM_STARTUP';
export const CLEAR_SYSTEM_STARTUP = 'CLEAR_SYSTEM_STARTUP';
